module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/等离子清洗机.22b6d1e8.png";